import React, { useState } from "react";
import classes from "./ReverseQuizInfoModal.module.css";
import WrongAudio from "./WrongAudio";
import CorrectAudio from "./CorrectAudio";
import { FaXmark } from "react-icons/fa6";
import { useTranslation } from "react-i18next";

const ReverseQuizInfoModal = ({ closeModal }) => {

    const [correct, setCorrect] = useState(null);
    const [wrong, setWrong] = useState(null);

    const {t}=useTranslation();

    const [wrongSound, setWrongSound] = useState(null);
    const [correctSound, setCorrectSound] = useState(null);

    const checkAnswerAndNextQuestion = (selectedOption, selectedOptionName) => {
        if (
            2 == selectedOption || "Chess" == selectedOptionName
        ) {
            setCorrect(selectedOption);
            setCorrectSound(true);
            setWrongSound(false);
            setWrong(null);
            setTimeout(() => {
                setWrong(null);
                setCorrect(null);
                setCorrectSound(false);
                setWrongSound(false);
            }, 2000);

        } else {
            setWrong(selectedOption);
            setWrongSound(true);
            setCorrect(null);
            setCorrectSound(false);
            setTimeout(() => {
                setWrong(null);
                setCorrect(null);
                setCorrectSound(false);
                setWrongSound(false);
            }, 2000);
        }
    };

    return (
        <div className={classes.modal_container} onClick={() => closeModal()}>
            {wrongSound && <WrongAudio />}
            {correctSound && <CorrectAudio />}
            <div className={classes.modal_subcontainer} onClick={(e) => e.stopPropagation()}>
                  <div className={classes.close_btn_container}>
                    <button type="button" className={classes.close_btn} onClick={() => closeModal()}>
                        <FaXmark className={classes.close_icon} />
                    </button>
                </div>
                <h2 className={classes.text_main}>{t("138")}</h2>
                <ul>
                    <li className={classes.text_secondary_2}>
                        {t("139")}
                    </li>
                    <li className={classes.text_secondary_2}>
                        {t("140")}
                    </li>
                    <li className={classes.text_secondary_2}>
                        {t("141")}
                    </li>
                </ul>
                <h3 className={classes.text_main_2}>{t("142")}</h3>

                <div className={classes.question_container}>
                    <p className={classes.question}>{t("143")}</p>
                    {wrong == "1" && <p className={classes.tip}>{t("144")}</p>}
                    <div className={`${classes.option_container} ${correct == "1"
                        ? classes.right
                        : wrong == "1"
                            ? classes.wrong : null
                        }`}
                        onClick={() => {
                            checkAnswerAndNextQuestion(1, "Tennis")
                        }}>
                        <p className={classes.option}>{t("145")}</p>
                    </div>

                    {correct == "2" && <p className={classes.tip}>{t("146")}</p>}
                    <div className={`${classes.option_container} ${correct == "2"
                        ? classes.right
                        : wrong == "2"
                            ? classes.wrong : null
                        }`}
                        onClick={() => {
                            checkAnswerAndNextQuestion(2, "Chess")
                        }}
                    >
                        <p className={classes.option}>{t("147")}</p>
                    </div>
                    {wrong == "3" && <p className={classes.tip}>{t("148")}</p>}
                    <div className={`${classes.option_container} ${correct == "3"
                        ? classes.right
                        : wrong == "3"
                            ? classes.wrong : null
                        }`}
                        onClick={() => {
                            checkAnswerAndNextQuestion(3, "Basketball")
                        }}
                    >
                        <p className={classes.option}>{t("149")}</p>
                    </div>
                    {wrong == "4" && <p className={classes.tip}>{t("148")}</p>}
                    <div className={`${classes.option_container} ${correct == "4"
                        ? classes.right
                        : wrong == "4"
                            ? classes.wrong : null
                        }`}
                        onClick={() => {
                            checkAnswerAndNextQuestion(4, "Volleyball")
                        }}
                    >
                        <p className={classes.option}>{t("150")}</p>
                    </div>
                </div>



                {/* <div className={classes.btn_container}>
                    <button className={classes.close_button} onClick={closeModal}>
                        Close
                    </button>
                </div> */}
            </div>
        </div>
    );
};

export default ReverseQuizInfoModal;